import { Component, OnInit, inject } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import i18n from './translate';

@Component({
  selector: 'app-footer-simple',
  templateUrl: './footer-simple.component.html',
  styleUrls: ['./footer-simple.component.scss'],
  imports: [TranslateModule],
})
export class FooterSimpleComponent implements OnInit {
  private translate = inject(TranslateService);

  private static translationsLoaded = false;
  currentYear = new Date().getFullYear();

  ngOnInit() {
    if (!FooterSimpleComponent.translationsLoaded) {
      setTimeout(() => {
        for (const [lang, translation] of Object.entries(i18n)) {
          this.translate.setTranslation(lang, translation, true);
        }
        FooterSimpleComponent.translationsLoaded = true;
      });
    }
  }
}
